// Validation untuk Login, Register dan Lupa Password

export const ValTrack = async (data, captcha) => {
  const errors = [];

  if (!data.invoice) {
    errors.push({
      type: "invoice",
      message: "nomor invoice tidak boleh kosong",
    });
  }

  if (!data.no_hp) {
    errors.push({
      type: "no_hp",
      message: "nomor telepon tidak boleh kosong",
    });
  } else if (
    !/^[0-9]*$/.test(data.no_hp) ||
    data.no_hp.length < 11 ||
    data.no_hp.length > 13
  ) {
    errors.push({
      type: "no_hp",
      message: "nomor telepon tidak sesuai format",
    });
  }

  if (!data.captcha) {
    errors.push({
      type: "captcha",
      message: "kode captcha tidak boleh kosong",
    });
  } else if (data.captcha !== captcha) {
    errors.push({
      type: "captcha",
      message: "kode captcha tidak sama",
    });
  }

  return errors;
};
